import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import SensorSparkline, { SparkPoint } from './SensorSparkline';
import { FridgePoint } from './useFridgeTempHistory';

interface HvacSparklineProps {
  points: FridgePoint[];
  color?: string;
  width?: number;
  height?: number;
}

/** Fridge-history adapter around the shared SensorSparkline. */
const HvacSparkline: React.FC<HvacSparklineProps> = ({ points, color, width, height }) => {
  const sparkPoints = useMemo<SparkPoint[]>(
    () => points.map((p) => ({ time: p.time, value: p.temp })),
    [points],
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <SensorSparkline points={sparkPoints} color={color} width={width} height={height} />
    </Box>
  );
};

export default HvacSparkline;
